let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8JZKd"), load("kTv6A")]).then(() => parcelRequire('hGK0I'));